<script setup lang="ts">
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/cn';

type Padding = 'none' | 'md' | 'lg';

const card = cva(
  'bg-surface border border-border rounded-lg shadow-sm',
  {
    variants: {
      padding: {
        none: 'p-0',
        md:   'p-4',
        lg:   'p-6',
      },
    },
    defaultVariants: { padding: 'md' },
  },
);

interface Props {
  padding?: Padding;
  class?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <section :class="cn(card({ padding }), props.class)">
    <header v-if="$slots.header" class="mb-3">
      <slot name="header" />
    </header>
    <slot />
    <footer v-if="$slots.footer" class="mt-3 pt-3 border-t border-border">
      <slot name="footer" />
    </footer>
  </section>
</template>
